export class EqualizationResult {
  sheetId: number;
  needed: Set<any>;
  missing: Set<string>;
  ambiguous: any;
}
